/* eslint-disable no-underscore-dangle */

class DiscoveryLevelRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("discovery-level--column");
        this._rootElem.component = this._model;

        this._registerListeners();

        this.render();
    }

    /** ***************************************** */
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /** ***************************************** */
    _shutdown() {
        return new Promise((resolve /* ,reject */) => {
            this._unregisterListeners();
            this._model = undefined;
            this._rootElem.remove();
            resolve();
        });
    }

    _registerListeners() {
        this._model.on("Update", (this._onUpdate = this._onUpdate.bind(this)));
    }

    _unregisterListeners() {
        this._model.removeListener("Update", this._onUpdate);
    }

    /** **************************************** */
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /** **************************************** */
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        return new Promise((resolve /* ,reject */) => {
            this._updateDiscovery();
            resolve();
        });
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /** **************************************** */
    /* END COMPONENT RENDERER METHODS */
    /* START HANDLER METHODS */
    /** **************************************** */
    _onUpdate() {
        this._updateDiscovery();
    }

    /** **************************************** */
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /** **************************************** */

    _updateDiscovery() {
        this._rootElem.innerText = this._model.getDiscoveryLevel();
    }

    /** **************************************** */
    /*  END PRIVATE API METHODS */
    /** **************************************** */
}

export default DiscoveryLevelRenderer;
